// ** React Imports
import { lazy } from 'react';

const InventoryRoutes = [
  {
    path: 'inventory',
    component: lazy(() => import('views/inventory')),
  },
  {
    path: 'inventory/:bucket',
    component: lazy(() => import('views/inventory/inventory-bucket')),
  },
];

export default InventoryRoutes;
